/**
 * Feed Chunks Configuration
 *
 * Configuración de URLs para feed-chunks:
 * - PRODUCCIÓN (netlify): Se cargan desde https://devlusajanewsiafeed.netlify.app/assets/
 * - DESARROLLO: Se cargan desde /feed-chunks/ (local)
 */

export default {
  // URL base para los feed-chunks según el entorno
  baseUrl: process.env.NODE_ENV === 'production'
    ? 'https://devlusajanewsiafeed.netlify.app/'
    : '/feed-chunks/',

  // Debug mode
  debuibug: process.env.NODE_ENV === 'development',
};
